import { Injectable, Injector } from '@angular/core';
import { BitfApiService } from '@bitf/services/api/bitf-api.service';
import { IBitfApiResponse } from '@interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NewsletterService extends BitfApiService {
  constructor(public injector: Injector) {
    super('newsletter', injector);
  }

  send(data: {
    to: {
      email: string;
      name?: string;
      surname?: string;
    }[];
    subject: string;
    content: string[];
  }): Observable<IBitfApiResponse<void>> {
    return super.post<void>({
      action: 'send',
      body: data,
    });
  }
}
